import axios from 'axios';
import { withRetry } from './apiRetry';
import { sessionRedirect } from './sessionRedirect';
import { tryRefresh } from './refreshToken';

const API_URL = '';

const clientApi = axios.create({ 
  baseURL: API_URL, 
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' } 
});

clientApi.interceptors.request.use((config) => { 
  const token = localStorage.getItem('client_token'); 
  if (token) config.headers.Authorization = `Bearer ${token}`; 
  return config; 
});

// Retry transient failures before giving up
withRetry(clientApi);

clientApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';
    const isAuthCall = /\/auth\/(login|refresh)/i.test(url);
    if (status === 401 && !isAuthCall && !error.config.__hasRetriedAuth) {
      const newToken = await tryRefresh('client');
      if (newToken) {
        error.config.__hasRetriedAuth = true;
        error.config.headers.Authorization = `Bearer ${newToken}`;
        return clientApi.request(error.config);
      }
      sessionRedirect('client');
    }
    return Promise.reject(error);
  }
);

export default clientApi;
